import { useCallback } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { useCountry } from '../../components/CountrySelector';
import {
  GET_SHIPMENT_LIST_QUERY,
  GetShipmentListQuery,
  GetShipmentListQueryVariables
} from './shipmentList.rest';

export const useShipmentList = () => {
  const { country } = useCountry();

  const { data, loading, error, fetchMore: fetchMoreFn } = useQuery<
    GetShipmentListQuery,
    GetShipmentListQueryVariables
  >(GET_SHIPMENT_LIST_QUERY, {
    variables: {
      countryCode: country.alpha2Code,
      pageNumber: 1
    }
  });

  const updateQuery = useCallback(
    (previousResults: GetShipmentListQuery, { fetchMoreResult }) => ({
      getShipmentList: {
        ...fetchMoreResult.getShipmentList,
        data: [...previousResults.getShipmentList.data, ...fetchMoreResult.getShipmentList.data],
        included: [
          ...previousResults.getShipmentList.included,
          ...fetchMoreResult.getShipmentList.included
        ]
      }
    }),
    []
  );

  const fetchMore = useCallback(
    (pageNumber: number) => {
      fetchMoreFn({
        updateQuery,
        variables: {
          pageNumber
        }
      });
    },
    [fetchMoreFn, updateQuery]
  );

  return {
    shipments: data?.getShipmentList.data,
    orderItems: data?.getShipmentList.included,
    pagination: data?.getShipmentList.meta.pagination,
    loading,
    error,
    fetchMore
  };
};
